import axios from 'axios';

const baseUrl = process.env.REACT_APP_GITO_API_URL + "/customers";
//const baseUrl = "https://localhost:7241";

// Function to get all customers
export async function getAllCustomers(apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/Customer/get-all-customers`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch customers');
    }
}

export async function getAllCustomersByOrganizationPublicId(organizationPublicId, apiAccessToken) {
    const suffix = organizationPublicId ? `/${organizationPublicId}` : "";
    try {
        const response = await axios.get(
            `${baseUrl}/Customer/get-all-customers-by-organization-public-id${suffix}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || "Failed to fetch customers");
    }
}

export async function getAllCustomerWithAccessToSite(chargingSitePublicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/Customer/get-customers-with-access-for-site/${chargingSitePublicId}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch charging sites"
        );
    }
}

export async function getAllCustomersForSessions(apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/Customer/get-all-customers-for-sessions`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch customers for sessions');
    }
}

export async function getAllInternalCustomers(apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/Customer/get-all-internal-customers`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch customers');
    }
}

export async function getAllCustomersByUser(userPublicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/Customer/get-customers-by-user/${userPublicId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch customers');
    }
}

// Function to get a specific customer by customerPublicId
export async function getCustomer(customerPublicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/Customer/get-customer/${customerPublicId}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch customer');
    }
}

// Function to create a new customer
export async function createCustomer(customerData, apiAccessToken) {
    try {
        const response = await axios.post(`${baseUrl}/Customer/create-customer`, customerData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to create customer');
    }
}

// Function to update an existing customer
export async function updateCustomer(customerData, apiAccessToken) {
    try {
        const response = await axios.put(`${baseUrl}/Customer/update-customer`, customerData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to update customer');
    }
}

// Function to delete a customer by customerPublicId
export async function deleteCustomer(customerPublicId, apiAccessToken) {
    try {
        const response = await axios.delete(`${baseUrl}/Customer/delete-customer/${customerPublicId}`, {
            headers: {
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to delete customer');
    }
}

// Function to get customer third-party system mapping for a customer
export async function getCustomerThirdPartySystemMapping(customerPublicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/CustomerThirdPartySystemMapping/get-customer-third-party-system-mapping-for-customer/${customerPublicId}`, {
            headers: {
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to fetch third-party system mapping');
    }
}

// Function to add customer third-party system mapping
export async function addCustomerThirdPartySystemMapping(mappingData, apiAccessToken) {
    try {
        const response = await axios.post(`${baseUrl}/CustomerThirdPartySystemMapping/add-customer-third-party-system-mapping`, mappingData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to add third-party system mapping');
    }
}

// Function to update customer third-party system mapping
export async function updateCustomerThirdPartySystemMapping(mappingData, apiAccessToken) {
    try {
        const response = await axios.put(`${baseUrl}/CustomerThirdPartySystemMapping/update-customer-third-party-system-mapping`, mappingData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to update third-party system mapping');
    }
}

// Function to delete customer third-party system mapping
export async function deleteCustomerThirdPartySystemMapping(thirdPartySystemPublicId, customerPublicId, thirdPartySystemExternalId, apiAccessToken) {
    try {
        const response = await axios.delete(`${baseUrl}/CustomerThirdPartySystemMapping/delete-customer-third-party-system-mapping/${customerPublicId}/${thirdPartySystemPublicId}/${thirdPartySystemExternalId}`, {
            headers: {
                'Authorization': `Bearer ${apiAccessToken}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail || 'Failed to delete third-party system mapping');
    }
}

